
namespace TabAurous.ProductDevelopment {

    
    @Serenity.Decorators.registerClass()
    export class SpecSheetSelectGrid extends _Ext.GridBase<SpecSheetItemsRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.SpecSheetItems'; }
        protected getDialogType() { return SpecSheetItemsDialog; }
        protected getIdProperty() { return SpecSheetItemsRow.idProperty; }
        protected getInsertPermission() { return SpecSheetItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SpecSheetItemsRow.localTextPrefix; }
        protected getService() { return SpecSheetItemsSelectService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
    

        constructor(container: JQuery, options) {
            super(container, options);

            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;  
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): SalesOrder.SalesOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }




        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

        protected getViewOptions() {
            var opt = super.getViewOptions();

            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}